import { ReactElement } from 'react';
import { CATEGORY_CONFIG } from '../../constants';
import { EfficiencyCategory } from '../../types';
import { EnergyEfficiencyTooltip } from '../GraphTooltip';
import { EfficiencyBar } from './styles';

interface EnergyEfficiencyBarProps {
  category: EfficiencyCategory;
  disabled: boolean;
}
export function EnergyEfficiencyBar({
  category,
  disabled,
}: Readonly<EnergyEfficiencyBarProps>): ReactElement {
  const { color, width } = CATEGORY_CONFIG[category];

  return (
    <>
      <EfficiencyBar
        category={category}
        color={color}
        width={width}
        data-tip
        data-for={`tooltip-efficiency-${category.toLowerCase()}`}
        disabled={disabled}
        data-testId={`efficiency-bar-${category}`}
      >
        <span>{category}</span>
      </EfficiencyBar>
      <EnergyEfficiencyTooltip
        category={category}
        disabled={disabled}
      />
    </>
  );
}
